// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__c3K5f","box":"WorkspacesBox_box__2C8_k","node":"WorkspacesBox_node__jHGyq"};